import axios from "axios";
import { buildApiUrl } from "../utils/api";
import { getToken } from "../utils/auth";


export const getNotificationCount = async () => {
  const token = getToken();
  const res = await axios.get(buildApiUrl("/api/notifications/count"), {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  // API: { data: { count: number } }
  return { count: res.data?.data?.count ?? 0 };
};


export const getNotifications = async () => {
  const token = getToken();
  const res = await axios.get(buildApiUrl("/notifications"), {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  
  const result = {
    notifications: res.data?.data?.notifications ?? [],
    leadWaitingCount: res.data?.data?.leadWaitingCount ?? 0,
    clientWaitingCount: res.data?.data?.clientWaitingCount ?? 0,
  };
  
  return result;
};
